import { FilterAlt } from "@mui/icons-material";
import { TreeItem, TreeView } from "@mui/lab";
import { Box, Button, Drawer, IconButton, Typography } from "@mui/material";
import {
  DataGridPremium,
  GridCallbackDetails,
  GridCloseIcon,
  GridColDef,
  GridColumnVisibilityModel,
  GridFilterModel,
  GridPinnedColumns,
  GridSortModel,
  GridToolbar,
  getGridStringOperators,
} from "@mui/x-data-grid-premium";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  EXPORT_AUDIT_ENTITY_IDENTIFIER_URL,
  fetchAuditFieldModification,
  fetchOperationListByEntityId,
} from "./audit";
import {
  canParseToJson,
  firstWordCase,
  formName,
  getAllIds,
} from "../../assets/utils";
import axios from "axios";
import Cookies from "js-cookie";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { EventEmitter } from "stream";
import { useDataGridLocalText } from "../../hooks/useDataGridLocaleText";
import service, { basicUrl } from "../../Services/apiheader";
import Loading from "../../components/Loading";
import eventBus from "./eventBus";
import { RTQ_EVENTS } from "../../Types";
import CloseIcon from "@mui/icons-material/Close";
import { fetchReasons } from "../../api/apiFunctions";
import { fetchFormFields } from "../../api/apiFunctions";
import NoRecordsFound from "../../components/NoRecordsFound";

const AuditReportDrawer = (props: any): JSX.Element => {
  const {
    openAddPopup,
    handleCancel,
    isEntity,
    identifierData,
    setOpenAddPopup,
    setIdentifierData,
    setReportDrawerList,
    setIsEntityReport,
    recordId,
    xevmpdId
  } = props;
  const { t } = useTranslation();
  const { localeText } = useDataGridLocalText();
  const { enqueueSnackbar } = useSnackbar();

  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [indetifierList, setIndetifierList] = useState([]);
  const [currentEntityList, setCurrentEntityList] = useState([]);
  const [fieldModifications, setFieldModifications] = useState<any>([]);
  const [rowCount, setRowCount] = useState(0);
  const [isCategoryData, setIsCategoryData] = useState(false);
  const [isAuditIdentifierClicked, setIsAuditIdentifierClicked] =
    useState(false);
  const [numericPart, setnumericPart] = useState("");
  const [filterModel, setFilterModel] = useState<GridFilterModel>();
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});
  const [relatedRecords, setRelatedRecords] = useState([
    {
      recordId: "0000001",
      queryTitle: "testtest",
    },
  ]);
  const [gridColumnVisibility, setGridColumnVisibility] = useState(
    columnVisibilityModel
  );
  const [pinnedColumns, setPinnedColumns] = React.useState<GridPinnedColumns>({
    // left: ['productName'],
    right: ["action"],
  });

  const handlePinnedColumnsChange = React.useCallback(
    (updatedPinnedColumns: GridPinnedColumns) => {
      setPinnedColumns(updatedPinnedColumns);
    },
    []
  );
  const [loadingWord, setLoadingWord] = useState("");
  const [isDataReady, setIsDataReady] = useState(false);

  const [sortModel, setSortModel] = useState<GridSortModel>();

  const pageNumRef = useRef(pageNum);
  pageNumRef.current = pageNum;
  const pageSizeRef = useRef(pageSize);
  pageSizeRef.current = pageSize;

  const handleClickAuditIdentifier = (value: any) => {
    const num = value.formattedValue.match(/\d+/)[0];
    setnumericPart(num);
    setIsAuditIdentifierClicked(true);
    setOpenAddPopup(true);
    setIdentifierData(value.row);
    setReportDrawerList(value);
    setIsEntityReport(false);
    getIdentifiedInformation(num);
  };

  const transformTreeData = (data: any) => {
    const isDataJson = canParseToJson(data);
    if (data && isDataJson) {
      return JSON.parse(data);
    } else {
      return false;
    }
  };

  const auditUpColumns: GridColDef[] = [
    {
      field: "entityIdentifier",
      headerName: t("common.entityIdentifier"),
      minWidth: 105,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityName",
      headerName: t("common.entityName"),
      flex: 1,
      minWidth: 110,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip
            title={cellValues.value || "No Value"}
            placement="left-start"
          >
            <div>{cellValues.value || "No Value"}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityCreatedByName",
      headerName: t("common.createdBy"),
      minWidth: 100,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityCreatedDate",
      headerName: t("common.entityCreatedDate"),
      minWidth: 170,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityModifiedByName",
      headerName: t("common.modifiedBy"),
      minWidth: 100,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityModifiedDate",
      headerName: t("common.entityModifiedDate"),
      minWidth: 155,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
  ];
  const auditDownColumns: GridColDef[] = [
    {
      field: "fieldName",
      headerName: t("common.fieldName"),
      width: 245,
      // disableColumnMenu: true,
      // sortable: false,
      renderCell: (cellValues: any) => {
        return (
          <NoMaxWidthTooltip title={cellValues.value} placement="left-start">
            <div>{!cellValues.value ? " " : cellValues.value}</div>
          </NoMaxWidthTooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "oldValue",
      headerName: t("common.beforeModification"),
      flex: 1,
      minWidth: 245,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (cellValues: any) => {
        const cellData = transformTreeData(cellValues.value);
        const expandedId = getAllIds(cellData, []);
        return (
          <>
            {cellData.length > 0 ? (
              <TreeView defaultExpanded={["root"]} expanded={expandedId}>
                {renderTree(cellData, expandedId[0])}
              </TreeView>
            ) : (
              <NoMaxWidthTooltip
                title={cellValues.value}
                placement="left-start"
              >
                <div>
                  {typeof cellValues.value === "boolean"
                    ? cellValues.value
                      ? "Yes"
                      : "No"
                    : Array.isArray(cellValues.value)
                      ? cellValues.value.length
                        ? cellValues.value.join(", ")
                        : "-"
                      : !cellValues.value || cellData.length === 0
                        ? "-"
                        : cellValues.value}
                </div>
              </NoMaxWidthTooltip>
            )}
          </>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "newValue",
      headerName: t("common.afterModification"),
      width: 245,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (cellValues: any) => {
        const cellData = transformTreeData(cellValues.value);
        const expandedId = getAllIds(cellData, []);
        return (
          <>
            {cellData.length > 0 ? (
              <TreeView
                defaultExpanded={["root"]}
                expanded={expandedId}
                style={{ height: "100%" }}
              >
                {renderTree(cellData, expandedId[0])}
              </TreeView>
            ) : (
              <NoMaxWidthTooltip
                title={cellValues.value}
                placement="left-start"
              >
                <div>
                  {typeof cellValues.value === "boolean"
                    ? cellValues.value
                      ? "Yes"
                      : "No"
                    : Array.isArray(cellValues.value)
                      ? cellValues.value.length
                        ? cellValues.value.join(", ")
                        : "-"
                      : !cellValues.value || cellData.length === 0
                        ? "-"
                        : cellValues.value}
                </div>
              </NoMaxWidthTooltip>
            )}
          </>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
  ];

  const entityUpColumns: GridColDef[] = [
    {
      field: "entityIdentifier",
      headerName: t("common.entityIdentifier"),
      minWidth: 300,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "entityName",
      headerName: t("common.entityName"),
      minWidth: 400,
      flex: 1,
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value} placement="left-start">
            <div>{cellValues.value}</div>
          </Tooltip>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
  ];
  const entityDownColumns: GridColDef[] = [
    {
      field: "recordId",
      headerName: t("common.auditIdentifier"),
      width: 183,
      sortable: true,
    renderCell: (cellValues: any) => {
  return (
    <button
      onClick={() => handleClickAuditIdentifier(cellValues)}
      style={{
        textDecoration: "none",
            color: "rgb(41, 94, 241)",
        cursor: "pointer",
        border: "none",
        background: "transparent",
        padding: 0,
        fontSize: "inherit",
      }}
      aria-label={`View audit identifier ${cellValues.value}`}
      type="button"
    >
      {cellValues.value}
    </button>
  );
}
,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "operationType",
      headerName: t("common.operationType"),
      width: 170,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "operatorUsername",
      headerName: t("common.user"),
      width: 190,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
    {
      field: "operationDate",
      headerName: t("common.operationDate"),
      width: 180,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== "isAnyOf"
      ),
    },
  ];

  //@ts-ignore
  const moduleName: string = "Xevmpd";

  // const downLoadEntityList = () => {
  //     let params = {
  //         api: EXPORT_AUDIT_ENTITY_IDENTIFIER_URL,
  //         data: {
  //             entityId: `${recordId}`,
  //             moduleName: moduleName
  //         }
  //     }

  // }
  const downloadFileCommon = (
    url: string,
    data = {},
    enqueueSnackbar: any,
    type = ""
  ) => {
    const dataLength = Object.keys(data).length;
    let executePolling = setTimeout(() => {
      service({
        method: dataLength ? "post" : "get",
        url: url,
        responseType: "arraybuffer",
        data: data,
      })
        .then((res: any) => {
          if (
            res.headers["export-status"] == 3 ||
            type === "download template"
          ) {
            eventBus.emit(RTQ_EVENTS.COMMON.EXPORT_FILE_END);
            eventBus.emit(RTQ_EVENTS.ADMIN.DOWNLOAD_TEMPLATE_END);
            clearTimeout(executePolling);

            let fileName = res.headers["content-disposition"]
              .split(";")[1]
              .split("filename=")[1];

            if (!res.data) {
              setLoading(false);
              return;
            }

            let url = window.URL.createObjectURL(new Blob([res.data]));
            let element = document.createElement("a");
            element.style.display = "none";
            element.href = url;
            element.setAttribute("download", decodeURIComponent(fileName));
            document.body.appendChild(element);
            element.click();

            setTimeout(() => {
              setLoading(false);
              setLoadingWord("");
            }, 1000);

            setTimeout(() => {
              document.body.removeChild(element);
              window.URL.revokeObjectURL(url);
            }, 100);
          } else {
            downloadFileCommon(url, data, enqueueSnackbar, type);
          }
        })
        .catch((err: any) => {
          clearTimeout(executePolling);
          eventBus.emit(RTQ_EVENTS.COMMON.EXPORT_FILE_END);
          eventBus.emit(RTQ_EVENTS.ADMIN.DOWNLOAD_TEMPLATE_END);

          if (
            err?.response?.status == 401 ||
            err?.response?.data?.message === "unauthorized"
          ) {
            setLoading(false);
            setLoadingWord("");

            return;
          }

          if (enqueueSnackbar) {
            const unit8Msg: any = new Uint8Array(err.response.data);
            const error_msg = JSON.parse(
              String.fromCharCode.apply(null, unit8Msg)
            );
            enqueueSnackbar(error_msg.message, {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "center" },
            });
          }
          setLoading(false); // Hide loader on error
        });
    }, 2000);
  };

  const downLoadEntityList = () => {
    let timeZone = -new Date().getTimezoneOffset() / 60;

    let params = {
      entityId: recordId,
      moduleName: moduleName,
      timeZone: timeZone,
    };

    setLoadingWord(
      "We are currently exporting your data. Please check your downloads once its completed."
    );
    setLoading(true);
    downloadFileCommon(
      EXPORT_AUDIT_ENTITY_IDENTIFIER_URL,
      params,
      enqueueSnackbar
    );
  };

  const accessToken = Cookies.get("ACCESS_TOKEN");

  const fetchEditFormJson = async (formNameParam = "xEVMPD") => {
    try {
      const response = await axios.post(
        `${basicUrl}cm/form-manager/forms/settings`,
        {
          module: "xevmpd",
          formName: formNameParam,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      let raw = response.data?.data?.settingsJson;
      if (!raw) return [];

      // ✅ Handle both single and double stringified JSON safely
      if (typeof raw === "string") {
        try {
          raw = JSON.parse(raw);
        } catch {
          raw = JSON.parse(JSON.parse(raw));
        }
      }

      return Array.isArray(raw) ? raw : [];
    } catch (error) {
      console.warn(`⚠️ Failed to fetch settings for ${formNameParam}`, error);
      return [];
    }
  };

  const getIdentifiedInformation = async (num: any) => {
    setLoading(true);

    // ✅ Step 1: Fetch both dynamic fields and settingsJson
    const params = { module: "xevmpd", formName: "xEVMPD" };
    // ✅ Step 1: Fetch base form JSON
    const dynamicFields = await fetchFormFields({
      module: "xevmpd",
      formName: "xEVMPD",
    });
    const baseJson = await fetchEditFormJson("xEVMPD");

    // ✅ Step 2: Detect missing grid fields and fetch menus dynamically
    const menuNames = [
      "Presentation Details",
      "Pharmaceutical Product",
      "Product Indication",
      "Attachments",
      "Authorisation",
      "MAH",
      "ATC Code(s)",
      "Pharmacovigilance",
    ];

    const menuSettings: any[] = [];

    for (const menu of menuNames) {
      const menuJson = await fetchEditFormJson(menu);
      if (menuJson.length > 0) {
        menuSettings.push(...menuJson);
      } else {
      }
    }

    // Step 3: Merge everything into a single JSON source
    const json = [...baseJson, ...menuSettings].filter(Boolean);
    console.log("Combined settings length:", json.length);

    console.log("Form Settings JSON:", json);
    console.log("Parsed JSON Type:", typeof json);
    console.log("First Field Example:", json?.[0]);

    console.log(
      "Has gridFields?",
      json.some((f: any) => !!f.gridFields)
    );

    // ✅ Step 2: Fully recursive extractor for settings JSON (any nesting depth)
    const extractAllFields = (
      items: any[]
    ): Record<string, { label: string; type: string }> => {
      const result: Record<string, { label: string; type: string }> = {};

      const recurse = (obj: any) => {
        if (!obj) return;

        // Register field label
        if (obj.field) {
          result[obj.field.toLowerCase()] = {
            label: obj.label || firstWordCase(obj.field),
            type: obj.type || "text",
          };
        }

        const nestedKeys = ["children", "columns", "gridFields"];
        for (const key of nestedKeys) {
          if (Array.isArray(obj[key])) {
            obj[key].forEach((child: any) => recurse(child));
          }
        }

        // 🔁 Explicitly go deeper into gridFields.children if present
        if (Array.isArray(obj.gridFields)) {
          obj.gridFields.forEach((gf: any) => {
            if (Array.isArray(gf.children)) {
              gf.children.forEach((child: any) => recurse(child));
            }
          });
        }
      };

      items.forEach((item) => recurse(item));
      return result;
    };

    // ✅ Step 3: Fully recursive extractor for dynamicFields JSON (mirrors the above)
    const extractDynamicFields = (
      fields: any[]
    ): Record<string, { label: string; type: string }> => {
      const result: Record<string, { label: string; type: string }> = {};

      const recurse = (f: any) => {
        if (!f) return;

        if (f.field) {
          result[f.field.toLowerCase()] = {
            label: f.label || f.column || firstWordCase(f.field),
            type: f.type || "text",
          };
        }

        const nestedKeys = ["children", "columns", "gridFields"];
        for (const key of nestedKeys) {
          if (Array.isArray(f[key])) {
            f[key].forEach((child: any) => recurse(child));
          }
        }

        // 🔁 Explicitly check gridFields.children too
        if (Array.isArray(f.gridFields)) {
          f.gridFields.forEach((gf: any) => {
            if (Array.isArray(gf.children)) {
              gf.children.forEach((child: any) => recurse(child));
            }
          });
        }
      };

      fields.forEach((f) => recurse(f));
      return result;
    };

    // ✅ Step 4: Merge and normalize
    const mergedLookup = {
      ...extractAllFields(json),
      ...extractDynamicFields(dynamicFields),
    };

    const fieldLookup: Record<string, { label: string; type: string }> = {};
    Object.keys(mergedLookup).forEach((key) => {
      fieldLookup[key.toLowerCase()] = mergedLookup[key];
    });

    // ✅ Step 5: Add custom static mappings
    fieldLookup["reasonToDisable"] = {
      label: "Reason for Disable",
      type: "text",
    };
    fieldLookup["commentsOnDisable"] = {
      label: "Disable Comments",
      type: "text",
    };
    delete fieldLookup["status"];
    delete fieldLookup["recordID"];
    

    // ✅ Step 6: Case-insensitive label resolver
    const getDisplayLabel = (fieldKey: string): string => {
      const key = fieldKey.toLowerCase();
      if (fieldLookup[key]?.label) return fieldLookup[key].label;
      return firstWordCase(fieldKey.replace(/^x\./, "").replace(/_/g, " "));
    };

    const keys = Object.keys(fieldLookup);
    console.log("keys", keys);

    // // Helper to get readable labels
    // const getDisplayLabel = (fieldKey: string): string => {
    //   const key = fieldKey.toLowerCase();
    //   if (fieldLookup[key]?.label) return fieldLookup[key].label;
    //   return firstWordCase(fieldKey.replace(/^x\./, "").replace(/_/g, " "));
    // };

    fetchAuditFieldModification(num)
      .then(async (res: any) => {
        if (res.data.code === 200) {
          const dataList = res.data.data;
          console.log("dataaaaaaaa", dataList);
          if (dataList) {
            const updatedData = {
              ...dataList,
              entityIdentifier: `${dataList.entityIdentifier}`, // Prefixing with 'DEV'
            };
            //@ts-ignore
            setIndetifierList([updatedData]);
            console.log(updatedData);
          } else {
            setIndetifierList([]);
          }

          // Utility function to format date
          const formatDate = (dateString: string) => {
            if (!dateString) return "";
            return dayjs(dateString).format("DD/MMM/YYYY");
          };

          const fm = res.data.data.fieldModifications;

          let updatedFieldModifications = fm;

          const promises = updatedFieldModifications.map(async (item: any) => {
            console.log(res.data);

            const formatValue = (value: any): string => {
              if (value === undefined || value === null || value === "") {
                return "-";
              } else if (Array.isArray(value)) {
                return value.length > 0 ? value.join(", ") : "-";
              } else if (typeof value === "object") {
                return JSON.stringify(value);
              } else {
                return String(value);
              }
            };

            let modifications: any[] = [];
           
            const menuName=updatedFieldModifications.find((mod:any)=>mod.fieldName==="menu")?.newValue;
            
            

            if (item.fieldName === "xevmpdData") {
              const oldValues = item.oldValue ? JSON.parse(item.oldValue) : {};
              const newValues = item.newValue ? JSON.parse(item.newValue) : {};

              // Process Regdata changes
              if (oldValues.xevmpdFormData || newValues.xevmpdFormData) {
                const oldRegData = oldValues.xevmpdFormData || {};
                const newRegData = newValues.xevmpdFormData || {};

                const hasReasonToDisable =
                  Object.keys(newRegData).includes("reasonToDisable");
                console.log("Has reasonToDisable? ", hasReasonToDisable);
                let reasons: any;

                if (hasReasonToDisable) {
                  try {
                    reasons = await fetchReasons();
                  } catch (error) {
                    console.error("Failed to fetch reasons:", error);
                  }
                }

                // Compare and add modifications for Regdata fields
                Object.keys({ ...oldRegData, ...newRegData }).forEach(
                  async (key) => {
                    let oldValue = formatValue(oldRegData[key]);
                    let newValue = formatValue(newRegData[key]);
                    if (key === "reasonToDisable") {
                      oldValue =
                        reasons.find((reason: any) => reason.id === oldValue)
                          ?.name ?? "-";
                      newValue = reasons.find(
                        (reason: any) => reason.id === newValue
                      )?.name;
                    }
                    if (oldValue !== newValue) {
                      modifications.push({
                        id: `regdata-${key}`,
                        fieldName: t(key),
                        oldValue: oldValue,
                        newValue: newValue,
                      });
                    }
                  }
                );
              }

              // ✅ Handle MenuData comparison for both single and multi-grid menus
              if (oldValues.MenuData || newValues.MenuData) {
                const oldMenuData = oldValues.MenuData || {};
                const newMenuData = newValues.MenuData || {};

                const allSections = new Set([
                  ...Object.keys(oldMenuData),
                  ...Object.keys(newMenuData),
                ]);

                const fallbackKeys = [
                  "eVCode",
                  "procedureType",
                  "authorizationNumber",
                ];

                for (const sectionKey of Array.from(allSections)) {
                  let oldSection = oldMenuData[sectionKey];
                  let newSection = newMenuData[sectionKey];

                  // 🩹 Normalize missing sections so new records show in audit
                  if (!oldSection && newSection) {
                    if (Array.isArray(newSection)) {
                      oldSection = newSection.map(() => ({}));
                    } else if (typeof newSection === "object") {
                      oldSection = Object.keys(newSection).reduce(
                        (acc: Record<string, any>, k) => {
                          acc[k] = "-";
                          return acc;
                        },
                        {} as Record<string, any>
                      );
                    } else {
                      oldSection = {};
                    }
                  }

                  if (!newSection && oldSection) {
                    if (Array.isArray(oldSection)) {
                      newSection = oldSection.map(() => ({}));
                    } else if (typeof oldSection === "object") {
                      newSection = Object.keys(oldSection).reduce(
                        (acc: Record<string, any>, k) => {
                          acc[k] = "-";
                          return acc;
                        },
                        {} as Record<string, any>
                      );
                    } else {
                      newSection = {};
                    }
                  }

                  // 🟢 Handle single-record (form) menus
                  if (
                    typeof oldSection === "object" &&
                    !Array.isArray(oldSection) &&
                    typeof newSection === "object" &&
                    !Array.isArray(newSection)
                  ) {
                    const allFields = new Set([
                      ...Object.keys(oldSection || {}),
                      ...Object.keys(newSection || {}),
                    ]);

                    for (const fieldKey of Array.from(allFields)) {
                      let oldValue = formatValue(oldSection?.[fieldKey]);
                      let newValue = formatValue(newSection?.[fieldKey]);

                      if (
                        (oldValue === "-" || !oldValue) &&
                        fallbackKeys.includes(fieldKey)
                      ) {
                        oldValue =
                          formatValue(oldValues?.xevmpdFormData?.[fieldKey]) ||
                          formatValue(oldValues?.Regdata?.[fieldKey]) ||
                          "-";
                      }
                      if (
                        (newValue === "-" || !newValue) &&
                        fallbackKeys.includes(fieldKey)
                      ) {
                        newValue =
                          formatValue(newValues?.xevmpdFormData?.[fieldKey]) ||
                          formatValue(newValues?.Regdata?.[fieldKey]) ||
                          "-";
                      }

                      if (fieldKey === "procedureType") {
                        oldValue =
                          oldValues?.Regdata?.procedureType || oldValue;
                        newValue =
                          newValues?.Regdata?.procedureType || newValue;
                      }

                      if (oldValue !== newValue) {
                        if (fieldKey.toLowerCase() === "evcode") continue;
                        const displayLabel =
                          getDisplayLabel(fieldKey) || firstWordCase(fieldKey);
                        modifications.push({
                          id: `menu-${sectionKey}-${fieldKey}`,
                          fieldName: displayLabel, // 🧩 Only label — no section name
                          oldValue,
                          newValue,
                        });
                      }
                    }
                  }

                  // 🟣 Handle multi-grid (array) menus
                  else if (
                    Array.isArray(oldSection) ||
                    Array.isArray(newSection)
                  ) {
                    const oldArray = Array.isArray(oldSection)
                      ? oldSection
                      : [];
                    const newArray = Array.isArray(newSection)
                      ? newSection
                      : [];
                    const maxLength = Math.max(
                      oldArray.length,
                      newArray.length
                    );

                    for (let i = 0; i < maxLength; i++) {
                      const oldRow = oldArray[i] || {};
                      const newRow = newArray[i] || {};

                      const allRowFields = new Set([
                        ...Object.keys(oldRow),
                        ...Object.keys(newRow),
                      ]);

                      for (const fieldKey of Array.from(allRowFields)) {
                        let oldValue = formatValue(oldRow?.[fieldKey]);
                        let newValue = formatValue(newRow?.[fieldKey]);

                        if (
                          (oldValue === "-" || !oldValue) &&
                          fallbackKeys.includes(fieldKey)
                        ) {
                          oldValue =
                            formatValue(
                              oldValues?.xevmpdFormData?.[fieldKey]
                            ) ||
                            formatValue(oldValues?.Regdata?.[fieldKey]) ||
                            "-";
                        }
                        if (
                          (newValue === "-" || !newValue) &&
                          fallbackKeys.includes(fieldKey)
                        ) {
                          newValue =
                            formatValue(
                              newValues?.xevmpdFormData?.[fieldKey]
                            ) ||
                            formatValue(newValues?.Regdata?.[fieldKey]) ||
                            "-";
                        }

                        if (oldValue !== newValue) {
                          const displayLabel =
                            getDisplayLabel(fieldKey) ||
                            firstWordCase(fieldKey);

                          const skipEvCode =
                            fieldKey.toLowerCase().includes("evcode") ||
                            displayLabel.toLowerCase().includes("ev code") ||
                            displayLabel
                              .toLowerCase()
                              .includes("attachment ev code");

                          if (skipEvCode) continue;
                          modifications.push({
                            id: `menu-${sectionKey}-row${i + 1}-${fieldKey}`,
                            fieldName: displayLabel, // 🧩 No (Row 1) or menu name
                            oldValue,
                            newValue,
                          });
                        }
                      }
                    }
                  }
                }
              }
           } else if (item.fieldName === "xevmpdRelatedData") {
              const oldRelatedData = item.oldValue
                ? JSON.parse(item.oldValue)
                : {};
              const newRelatedData = item.newValue
                ? JSON.parse(item.newValue)
                : {};



              // Compare and add modifications for xevmpdRelatedData fields
              Object.keys({ ...oldRelatedData, ...newRelatedData }).forEach(
                (key) => {
                  if (key === "rawFile" || key === "attachmentName" ||  key==="recordID") return;
                  

                  let oldValue = formatValue(oldRelatedData[key]);
                  let newValue = formatValue(newRelatedData[key]);
                  if(key==="status" && newValue==="Disable")
                    return;

                  // Special handling for attachment object - only track name changes
                  if (key === "attachment") {
                    const oldAttachment = oldRelatedData[key];
                    const newAttachment = newRelatedData[key];

                    // Check if name attribute changed in attachment object
                    const oldAttachmentName = oldAttachment?.name
                      ? formatValue(oldAttachment.name)
                      : "-";
                    const newAttachmentName = newAttachment?.name
                      ? formatValue(newAttachment.name)
                      : "-";

                    if (oldAttachmentName !== newAttachmentName) {
                      modifications.push({
                        id: `relateddata-attachment-name`,
                        fieldName: t("attachmentName"),
                        oldValue: oldAttachmentName,
                        newValue: newAttachmentName,
                      });
                    }

                    // Skip the main attachment comparison since we're only tracking name changes
                    return;
                  }

                  // For all other keys (except rawFile and attachment), do normal comparison
                  if (oldValue !== newValue) {
                    modifications.push({
                      id: `relateddata-${key}`,
                      fieldName: key==="reasonToDisable" ?"Reason" :t(key),
                      oldValue: oldValue,
                      newValue: newValue,
                    });
                  }
                }
              );
            } else {
              const fieldLabelMap: Record<string, string> = {
                created_by: "Created By",
                created_date: "Created Date",
                markfor_delete: "Disabled",
                modified_by: "Modified By",
                modified_date: "Modified Date",
                updated_by: "Updated By",
                updated_date: "Updated Date",
                markForDelete: "Deleted",
              };
              const fieldName = fieldLabelMap[item.fieldName] || item.fieldName;

              let oldValue = item.oldValue;
              let newValue = item.newValue;

              if (
                item.fieldName === "created_date" ||
                item.fieldName === "updated_date"
              ) {
                oldValue = oldValue ? formatDate(oldValue) : "-";
                newValue = newValue ? formatDate(newValue) : "-";
              }

              if (item.fieldName === "markForDelete") {
                oldValue =
                  oldValue === "0" ? "No" : oldValue === "1" ? "Yes" : oldValue;
                newValue =
                  newValue === "0" ? "No" : newValue === "1" ? "Yes" : newValue;
              }

              const excludedFields = [
                "menu",
                "section",
                "XevmpdId",
                "registrationId",
                "groupId",
                "xevmpdStatus",
                "majorVersion",
                "minorVersion"
              ];

              // Skip excluded fields
              if (!excludedFields.includes(item.fieldName)) {
                modifications.push({
                  id: item.fieldName ? item.fieldName : item.fieldName + "-",
                  fieldName: t(fieldName),
                  oldValue: oldValue,
                  newValue: newValue,
                });
              }
            }

            return modifications;
          });

          const fieldList = (await Promise.all(promises)).flat();

          const reorderedFieldList = fieldList.sort((a, b) => {
            if (
              a.fieldName === "Disabled" &&
              (b.fieldName === "Modified By" || b.fieldName === "Modified Date")
            ) {
              return -1;
            }
            if (
              (a.fieldName === "Modified By" ||
                a.fieldName === "Modified Date") &&
              b.fieldName === "Disabled"
            ) {
              return 1;
            }
            return 0;
          });

          console.log(
            "Reordered Field Modifications for Grid 2:",
            reorderedFieldList
          );
          setFieldModifications(reorderedFieldList);

          // Mark data as ready for export
          setIsDataReady(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getEntityIdentifiedInformation = (
    pageNum: number,
    pageSize: number
  ) => {
    setLoading(true);
    fetchOperationListByEntityId({
      entityId: "xEVMPD-"+xevmpdId,
      moduleName: "Xevmpd",
      pageNum: pageNum + 1,
      pageSize: pageSize,
    })
      .then((res: any) => {
        console.log(recordId);
        if (res.data.code === 200) {
          console.log(res);

          const updatedData = res.data.data.data.map((item: any) => ({
            ...item,
            entityIdentifier: `${recordId}`, // Prefixing with 'DEV'
          }));

          setIndetifierList(updatedData || []);
          console.log(updatedData);
          setRowCount(Number(res.data.total));

          if (updatedData[0]) {
            //@ts-ignore
            setCurrentEntityList([updatedData[0]]);
          } else {
            setCurrentEntityList([]);
          }

          // Mark data as ready for export
          setIsDataReady(true);
        }
      })
      .catch((err: any) => {
        if (
          err?.response?.status == 401 ||
          err?.response?.data?.message === "unauthorized"
        ) {
          return;
        }
        enqueueSnackbar(firstWordCase(err.response.data.message), {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "center" },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    handleCancel();
    setIsAuditIdentifierClicked(false);
  };

  // Custom export handler that ensures data is ready
  const handleExport = (format: "csv" | "excel" | "pdf") => {
    setLoading(true);
    console.log("Is Data Ready:", isDataReady);
    if (!isDataReady) {
      enqueueSnackbar("Data is still loading, please wait...", {
        variant: "warning",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
      return;
    }

    // Show success message that data is ready
    enqueueSnackbar(`Exporting ${format.toUpperCase()} with current data...`, {
      variant: "success",
      anchorOrigin: { vertical: "top", horizontal: "center" },
    });

    // Trigger the actual export after ensuring data is ready
    setTimeout(() => {
      const gridElement = document.querySelector(".MuiDataGrid-root");
      if (gridElement) {
        const exportButton = gridElement.querySelector(
          `[aria-label*="${format === "csv" ? "CSV" : "Excel"}"]`
        ) as HTMLElement;
        if (exportButton) {
          exportButton.click();
        }
      }
    }, 100);
    setLoading(false);
  };

  const renderTree = (nodes: any, firstId?: string) => {
    return nodes.map((el: any) => {
      return (
        <TreeItem
          key={el.id}
          nodeId={el.id?.toString()}
          label={el.name}
          disabled
          sx={{
            "& .MuiTreeItem-content .MuiTreeItem-label": {
              fontWeight:
                el.id?.toString().indexOf("##") < 0 ? "bold" : "normal",
            },
            "& .MuiTreeItem-content.Mui-disabled": {
              opacity: 1,
              padding: 0,
              marginLeft: "-24px",
            },
          }}
        >
          {Array.isArray(el.children) && el.children.length > 0
            ? renderTree(el.children)
            : null}
        </TreeItem>
      );
    });
  };

  useEffect(() => {
    if (!openAddPopup) return;
    setIsDataReady(false); // Reset data ready state when drawer opens
    getEntityIdentifiedInformation(0, 1000000);
  }, [filterModel, sortModel, pageNum, pageSize, openAddPopup]);

  useEffect(() => {
    if (openAddPopup) {
      if (!isEntity && !identifierData) {
        getIdentifiedInformation(identifierData.id);
      } else {
        setPageNum(0);
        setPageSize(10);
      }
    }
  }, [isEntity, openAddPopup, identifierData]);

  const isValueCategory = (data: any) => {
    data.map((item: any) => {
      setIsCategoryData(transformTreeData(item.newValue));
    });
  };
  useEffect(() => {
    isValueCategory(fieldModifications);
  }, [fieldModifications]);

  const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: "1000px",
    },
  });

  const isJsonValue = (value:any) => {
  if (typeof value === "object" && value !== null) return true;
  if (typeof value === "string") {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  }
  return false;
};

const formatValue = (value: any): { short: string; full: string } => {
  if (value == null) return { short: "", full: "" };

  if (isJsonValue(value)) {
    const str =
      typeof value === "string" ? value : JSON.stringify(value);

    return {
      short: str.length > 20 ? str.slice(0, 40) + "..." : str,
      full: str,
    };
  }

  const str = String(value);

  return {
    short: str,
    full: str,
  };
};
    const auditDownColumnsFormatted = auditDownColumns.map((col) => ({
  ...col,
  renderCell: (params: any) => {
  const { full } = formatValue(params.value);

  return (
    <Tooltip title={full || ""} arrow>
      <span
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
          cursor: "text"
        }}
      >
        {full}
      </span>
    </Tooltip>
  );
}
}));


  return (
    <Drawer
      anchor={"right"}
      open={openAddPopup}
      onClose={handleClose}
     SlideProps={{
          style: {
            marginTop: "40px",
            height: "calc(100vh - 40px)",
          }
        }}
    >
      <Box>
        <div className="slidebar_header">
          <Typography variant="h5">
            {isAuditIdentifierClicked
              ? `${t("common.auditIdentifier")} - (AR-${numericPart})`
              : t("common.entityIdentifier")}
          </Typography>

          <IconButton>
            <CloseIcon
              onClick={() => {
                handleClose();
              }}
              className="close icon-close-round mr-30"
            ></CloseIcon>
          </IconButton>
        </div>
      </Box>

      <div className="drawer-popup-body">
        <div>
          {!isAuditIdentifierClicked && (
            <div className="flex-end">
              <Button
                variant="contained"
                color="secondary"
                onClick={downLoadEntityList}
                disabled={moduleName === ""}
                className="download-button"
              >
                {t("common.downloadPDF")}
              </Button>
            </div>
          )}
        </div>

        {!isAuditIdentifierClicked && (
          <>
            <div>
              <Box>
                <DataGridPremium
                  hideFooter
                  columns={entityUpColumns}
                  columnHeaderHeight={32}
                  rows={currentEntityList}
                  slots={{
                    toolbar: GridToolbar,
                    // noRowsOverlay: NoRecordsFound,
                    // noResultsOverlay: NoRecordsFound,
                  }}
                  className="react-table audit-table-min"
                  rowHeight={38}
                  disableRowSelectionOnClick
                  hideFooterPagination={true}
                  sx={{
                    height:"100px",
                    "& .MuiDataGrid-toolbarContainer": {
                      flexDirection: "row-reverse",
                    },
                    // "& div[role=presentation].MuiDataGrid-virtualScroller": {
                    //   minHeight:
                    //     currentEntityList.length > 0 ? "61px" : "150px",
                    // },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      csvOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("csv"),
                      },
                      excelOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("excel"),
                      },
                      pdfOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("pdf"),
                      },
                    },
                  }}
                  localeText={localeText}
                  disableAggregation
                />
              </Box>
            </div>
            <div>
              <Box sx={{ flexGrow: 2 }}>
                <DataGridPremium
                  rows={indetifierList}
                  columnVisibilityModel={gridColumnVisibility}
                  columns={entityDownColumns}
                  columnHeaderHeight={32}
                  className="react-table audit-table"
                  rowHeight={38}
                  disableRowSelectionOnClick
                  filterModel={filterModel}
                  onFilterModelChange={(
                    filterModel: GridFilterModel,
                    details: GridCallbackDetails<"filter">
                  ) => {
                    setFilterModel(filterModel);
                  }}
                  localeText={localeText}
                  paginationModel={{ page: pageNum, pageSize: pageSize }}
                  onPaginationModelChange={(paginationModel: any) => {
                    setPageSize(paginationModel.pageSize);
                    setPageNum(paginationModel.page);
                  }}
                  pageSizeOptions={[10, 20, 50]}
                  pagination
                  components={{
                    ColumnMenuIcon: () => {
                      return <FilterAlt></FilterAlt>;
                    },
                  }}
                  slots={{
                    toolbar: GridToolbar,
                    noRowsOverlay: NoRecordsFound,
                    noResultsOverlay: NoRecordsFound,
                  }}
                  slotProps={{
                    toolbar: {
                      excelOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("excel"),
                      },
                      showQuickFilter: true,
                      utf8WithBom: true,
                      csvOptions: {
                        utf8WithBom: true,
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("csv"),
                      },
                      pdfOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("pdf"),
                      },
                    },
                  }}
                  pinnedColumns={pinnedColumns}
                  onPinnedColumnsChange={handlePinnedColumnsChange}
                  onColumnVisibilityModelChange={(newModel: any) =>
                    setGridColumnVisibility(newModel)
                  }
                  sortModel={sortModel}
                  disableAggregation
                />
              </Box>
            </div>
          </>
        )}
        {isAuditIdentifierClicked && (
          <>
            <div>
              <Box sx={{ flexGrow: 1 }}>
                <DataGridPremium
                  rows={indetifierList}
                  columns={auditUpColumns}
                  columnHeaderHeight={32}
                  className="react-table report-table audit-table-min"
                  rowHeight={38}
                  disableRowSelectionOnClick
                  hideFooterPagination={true}
                  sx={{
                    "& .MuiDataGrid-toolbarContainer": {
                      flexDirection: "row-reverse",
                    },
                    "& div[role=presentation].MuiDataGrid-virtualScroller": {
                      minHeight: "61px",
                    },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      csvOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("csv"),
                      },
                      excelOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("excel"),
                      },
                      pdfOptions: {
                        fileName: `${recordId}_Audit`,
                        onExport: () => handleExport("pdf"),
                      },
                    },
                  }}
                  localeText={localeText}
                  components={{
                    ColumnMenuIcon: () => {
                      return <FilterAlt></FilterAlt>;
                    },
                  }}
                  disableAggregation
                  slots={{
                  toolbar: GridToolbar,
                  // noRowsOverlay: NoRecordsFound,
                  // noResultsOverlay: NoRecordsFound,
                }}
                />
              </Box>
            </div>
            <div className="reportTips">{t("common.auditNoteMessage")}</div>

            <Box sx={{ flexGrow: 1 }}>
              <DataGridPremium
                rows={fieldModifications}
                columns={auditDownColumnsFormatted}
                columnHeaderHeight={32}
                className="react-table report-table audit-table"
                localeText={localeText}
                getRowHeight={() => (isCategoryData ? "auto" : 38)}
                disableRowSelectionOnClick
                hideFooterPagination={true}
                sx={{
                  "& .MuiDataGrid-toolbarContainer": {
                    flexDirection: "row-reverse",
                  },
                  "& div[role=presentation].MuiDataGrid-virtualScroller": {
                    minHeight: "61px",
                  },
                }}
                slots={{
                  toolbar: GridToolbar,
                  noRowsOverlay: NoRecordsFound,
                  noResultsOverlay: NoRecordsFound,
                }}
                disableAggregation
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    csvOptions: {
                      fileName: `${recordId}_Audit`,
                      onExport: () => handleExport("csv"),
                    },
                    excelOptions: {
                      fileName: `${recordId}_Audit`,
                      onExport: () => handleExport("excel"),
                    },
                    pdfOptions: {
                      fileName: `${recordId}_Audit`,
                      onExport: () => handleExport("pdf"),
                    },
                  },
                }}
              />
            </Box>
          </>
        )}
      </div>
      <Loading open={loading} wording={loadingWord}></Loading>
    </Drawer>
  );
};

export default AuditReportDrawer;
